import React from 'react';
import PropTypes from 'prop-types';
import HelmetWrapper from '../../HelmetWrapper';
import ProgressIndicator from '../../ProgressIndicator';
import ConfirmationBox from './ConfirmationBox';
import DefaultInventoryComponent from './DefaultInventoryComponent';

const propTypes = {
    email: PropTypes.string,
    orderID: PropTypes.string,
    reservations: PropTypes.array,
    subtotal: PropTypes.string,
    tax: PropTypes.string,
    total: PropTypes.string,
    modification: PropTypes.bool,
    inventoryComponent: PropTypes.func,
    print: PropTypes.func
};

const defaultProps = {
    email: 'r1s@r1s.com',
    orderID: '1234-1',
    reservations: [{
        order_details: {
            tour_date: '2020-01-01',
            tour_start: '3:00 PM',
            tour_end: '4:15 PM',
            description: 'Grand Avenue',
            recarea: 'Mammoth Cave National Park',
            location: 'Mammoth Cave National Park Tours'
        },
        subtotal: '5',
        quantity: '1'
    }],
    subtotal: '5',
    tax: '1',
    total: '6',
    modification: false,
    inventoryComponent: (key, reservation) => <DefaultInventoryComponent key={key} reservation={reservation} />,
    print: () => print()
};

const steps = [
    'Order Detail',
    'Shopping Cart',
    'Payment',
    'Confirmation'
];

export class OrderConfirmationPage extends React.PureComponent {
    render() {
        return (
            <div id="page-body" className="rec-order-confirmation-page">
                <HelmetWrapper title="Order Confirmation" />
                <section className="rec-order-confirmation-progress-wrap">
                    <div className="rec-order-confirmation-progress-row">
                        <div className="rec-grid-12-12">
                            <ProgressIndicator
                                steps={steps}
                                activeStep={4} />
                        </div>
                    </div>
                </section>
                <div className="rec-section-outer-wrap">
                    <div className="rec-nested-wrap">
                        <div className="rec-page-layout-full-width">
                            <ConfirmationBox {...this.props} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OrderConfirmationPage.propTypes = propTypes;
OrderConfirmationPage.defaultProps = defaultProps;

export default OrderConfirmationPage;
